import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import Main from './Main/Main';

ReactDOM.render(<Main />, document.getElementById('root'));
